import { Icon } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledIcon = styled(Icon)<{
  $enableHover: boolean;
  $isDisabled?: boolean;
}>`
  ${({ $enableHover, $isDisabled }) =>
    $enableHover &&
    !$isDisabled &&
    css`
      &:hover {
        transform: scale(1.25);
        cursor: pointer !important;
      }
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      path {
        fill: var(--surface-default);
        stroke: var(--icon-disabled);
      }
    `}
`;
